import styled from 'styled-components';

const StyledDSLabel = styled.div`
  .em-ds-labelValue__wrapper {
    margin-top: 8px;
    margin-bottom: 8px;
  }
`;
export default StyledDSLabel;
